import React from 'react';
import { clientLogos } from '../data/mockData';

export const TrustSection = () => {
  return (
    <section id="trust" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Delivering Outcomes for Government Clients
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">RHE Project Consulting supports government agencies delivering capital works projects across NSW.

          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center">
          {clientLogos.map((client) =>
          <div
            key={client.id}
            className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 flex items-center justify-center h-48">

              <img
              src={client.logo}
              alt={client.name}
              className={`max-w-full object-contain transition-all duration-300 ${client.large ? 'h-32' : 'h-16'}`} />

            </div>
          )}
        </div>
      </div>
    </section>);

};